<template>
	<div class="main">
		<div class="navigationBar">
			<div class="centerBox">
				<img src="../assets/images/logo.png" class="logo"/>
				<div class="navMenu">
					<a href="#">舜信首页</a>
					<a :href="this.$store.state.oldhttpUrl">山钢舜信</a>
				</div>
			</div>
		</div>
		<div  class="mask" v-if="isShow">
			<div class="mask-cover"></div>
			<div class="dialog" >
				<div class="dialog-span01" v-html="titleVal">尊敬的用户：根据公司发展需要</div>
				<div class="dialog-span02" v-html="contantVal">尊敬的用户：根据公司发展需要，舜信平台运营主体由“舜泰商业保理（上海）有限公司”
					正式变更为“山钢供应链管理（深圳）有限公司”。山钢供应链管理（深圳）有
					限公司是山钢集团的全资二级公司，平台运营主体变更后，服务宗旨、服务内容
					不变；变更前由舜泰商业保理（上海）有限公司签署的合同继续有效，各方均有
					义务继续履行。根据合规要求需要用户重新签订《用户注册与服务协议》和相关
					框架合作协议。感谢您理解和支持，后续我们将继续提供更加优质、便捷的服务。
					尊敬的用户：根据公司发展需要，舜信平台运营主体由“舜泰商业保理（上海）有限公司”
					正式变更为“山钢供应链管理（深圳）有限公司”。山钢供应链管理（深圳）有
					限公司是山钢集团的全资二级公司，平台运营主体变更后，服务宗旨、服务内容
					不变；变更前由舜泰商业保理（上海）有限公司签署的合同继续有效，各方均有
					义务继续履行。根据合规要求需要用户重新签订《用户注册与服务协议》和相关
					框架合作协议。感谢您理解和支持，后续我们将继续提供更加优质、便捷的服务。
					尊敬的用户：根据公司发展需要，舜信平台运营主体由“舜泰商业保理（上海）有限公司”
					正式变更为“山钢供应链管理（深圳）有限公司”。山钢供应链管理（深圳）有
					限公司是山钢集团的全资二级公司，平台运营主体变更后，服务宗旨、服务内容
					不变；变更前由舜泰商业保理（上海）有限公司签署的合同继续有效，各方均有
					义务继续履行。根据合规要求需要用户重新签订《用户注册与服务协议》和相关
					框架合作协议。感谢您理解和支持，后续我们将继续提供更加优质、便捷的服务。
				</div>
				<div class="text-c">
				<el-button type="primary" @click="colseDialog()" style="width: 120px">关闭</el-button>
				</div>
			</div>
		</div>

		<!-- banner  开始 -->
		<!--<div class="banner1" >
			<ul>
				<li><img src="../assets/images/index-banner01.jpg"></li>
				<li><img src="../assets/images/index-banner02.jpg"></li>
				<li><img src="../assets/images/index-banner03.jpg"></li>
			</ul>
		</div>-->
		<div class="showImg" >
			<!--//轮播图片-->
			<img  @mouseover="changeInterval(true)"
				  @mouseleave="changeInterval(false)"
				  v-for="(item) in imgArr"
				  :key="item.id"
				  :src="item.url"
				  alt="暂无图片"
				  v-show="item.id===currentIndex"
			>
			<!--//左侧按钮-->
			<div  @click="clickIcon('up')"   class="iconDiv icon-left">
				<i class="el-icon-caret-left"></i>
			</div>
			<!--//右侧按钮-->
			<div  @click="clickIcon('down')"  class="iconDiv icon-right">
				<i class="el-icon-caret-right"></i>
			</div>
			<!--//控制圆点-->
			<!--<div class="banner-circle">
				<ul>
					<li @click="changeImg(item.id)"
						v-for="(item) in imgArr"
						:key="item.id"
						:class="item.id===currentIndex? 'active': '' "
					></li>
				</ul>
			</div>-->
		</div>
		<!-- banner  结束 -->

		<div class="pageWrap">

		<div class="container fn_clear" style="width: 1200px;height: 100%;margin: 0 auto;">
			<div class="bianti" style="margin-top:100px;"><img src="../assets/images/biaoti01.png" width="423" height="57"/></div>
			<div class="comprehensive">
				<div style="width:1300px;">
					<div class="sive-list">
						<a href="index.html">
							<div class="sive-list01 yuanqu01"></div>
							<div class="sive-list02">
								<div class="sive-list02-1">智慧仓储</div>
								<div title="采用物联网终端技术将传统标准仓升级为数字监管仓，实现货物的穿透式管理。" class="sive-list02-2">采用物联网终端技术将传统标准仓升级为数字监管仓，实现货物的穿透式管理</div>

							</div>
						</a>
					</div>
					<div class="sive-list">
						<a href="###">
							<div class="sive-list01 yuanqu02"></div>
							<div class="sive-list02">
								<div class="sive-list02-1">在线交易</div>
								<div title="基于在线审批、电子合同签章、货款自动计算、账户体系结算等功能构建一站式在线贸易服务平台，实现业务数据的在线流转与实时传递" class="sive-list02-2">基于在线审批、电子合同签章、货款自动计算、账户体系结算等功能构建一站式在线贸易服务平台，实现业务数据的在线流转与实时传递</div>

							</div>
						</a>
					</div>
					<div class="sive-list">
						<a href="###">
							<div class="sive-list01 yuanqu03"></div>
							<div class="sive-list02">
								<div class="sive-list02-1">实时结算</div>
								<div title="通过贸易流程的线上化，精准控制货物与货款流向，实现货权货款的在线交割和实时结算" class="sive-list02-2">通过贸易流程的线上化，精准控制货物与货款流向，实现货权货款的在线交割和实时结算</div>

							</div>
						</a>
					</div>
					<div class="sive-list">
						<a href="###">
							<div class="sive-list01 yuanqu04"></div>
							<div class="sive-list02">
								<div class="sive-list02-1">行情动态</div>
								<div title="对接成熟的第三方市场行情数据源，通过货物信息自动同步国内外市场价格，实时掌控价格动向" class="sive-list02-2">对接成熟的第三方市场行情数据源，通过货物信息自动同步国内外市场价格，实时掌控价格动向</div>

							</div>
						</a>
					</div>
					<div class="sive-list">
						<a href="###">
							<div class="sive-list01 yuanqu05"></div>
							<div class="sive-list02">
								<div class="sive-list02-1">产销结合</div>
								<div title="依托物联网、人工智能、大数据等前沿技术，打造产销结合一体化在线交易平台，立足山钢集团主业根本，服务产业链上下游中小企业，厚植产业沃土，彰显国企担当。" class="sive-list02-2">依托物联网、人工智能、大数据等前沿技术，打造产销结合一体化在线交易平台，立足山钢集团主业根本，服务产业链上下游中小企业，厚植产业沃土，彰显国企担当。</div>

							</div>
						</a>
					</div>

					<div class="sive-list">
						<a href="###" class="gengduo">更多服务<em class="gengduo-1"></em></a>
					</div>

				</div>
			</div>
		</div>

			<!--凝信于智 · 创见未来-->
			<div class="ningxi fn_clear mt40" >
				<div class="bianti" style="margin-top:90px;"><img src="../assets/images/biaoti02.png" width="423" height="56"/></div>
				<div class="bianti" style="margin-top:78px;"><img src="../assets/images/shouye03.png" width="848" height="383"/></div>
				<div class="ningxi01 pro_num">累计交易规模&nbsp;<span class="ningxi01-1" id="pro_num02" v-html="totalAmount">113.76</span> 亿元</div>
				<!--<div class="ningxi01 pro_num">累计完成舜信开具 <span class="ningxi01-1" id="pro_num02" wicket:id="labOpenShunXinTotalAmount">668135</span> 元</div>-->
			</div>
			<!--凝信于智 · 创见未来-->
			<!--携手合作 · 共建共享-->
			<div class="xieshou container fn_clear">
				<div class="bianti" style="margin-top:92px;"><img src="../assets/images/biaoti03.png" width="423" height="66"/></div>
				<div class="xieshouty" style="width: 1200px;height: 100%;margin: 0 auto;">
					<div class="dianwei">权属单位</div>
					<ul style="list-style: none">
						<li>
							<a href="###">山钢股份</a>
						</li>
						<li>
							<a href="###">山钢日照</a>
						</li>
						<li>
							<a href="###">莱钢集团</a>
						</li>
						<li>
							<a href="###">济钢集团</a>
						</li>

						<li>
							<a href="###">山钢资本</a>
						</li>
						<li>
							<a href="###">山钢地产</a>
						</li>
						<li>
							<a href="###">莱钢建设</a>
						</li>
						<li>
							<a href="###">山钢耐材</a>
						</li>
						<li>
							<a href="###">淄博张钢</a>
						</li>
						<li>
							<a href="###">永锋淄博</a>
						</li>

						<li>
							<a href="###" class="geng-duo">+更多</a>
						</li>
					</ul>
				</div>
				<div class="hezuo-hb">
					<div class="dianwei">合作伙伴</div>
					<div style="width: 1200px;height: 100%;margin: 0 auto;">
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy01.jpg" width="248" height="94"/></a>
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy02.jpg" width="248" height="94"/></a>
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy03.jpg" width="248" height="94"/></a>
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy04.jpg" width="248" height="94"/></a>
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy05.jpg" width="248" height="94"/></a>
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy06.jpg" width="248" height="94"/></a>
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy07.jpg" width="248" height="94"/></a>
						<a href="###" class="hezuo-hb01"><img src="../assets/images/hy08.jpg" width="248" height="94"/></a>

					</div>

				</div>
			</div>
			<!--携手合作 · 共建共享-->


	</div>


<Footer></Footer>
	</div>
</template>
<script>
	import $common from '@/util/common.js'
	import Footer from '@/components/Footer.vue'

	import loading from '@/assets/images/loading.gif'
	export default {
		name: 'IndexNew',
		props: {
			
		},
		data() {
			return {
				showLogin: true,
				showSelect: false,

				nextTime: 120,
				timer: '',
				userList: [],
				loginModel: '',

				contantVal:'',
				totalAmount:'113.76',
				titleVal:'',

				isShow:false,
				//轮播图
				currentIndex :0,//当前所在图片下标
				timer:null,//定时轮询
				imgArr:[
					{	id:0,
						url:require("../assets/images/index-banner03.jpg"),
					},{
						id:1,
						url:require("../assets/images/index-banner04.jpg"),
					},
				]
			}
		},
		components: {
			Footer
		},
		mounted() {


			this.getList();

		},
		methods: {

			getList: function(){
				this.$http({
					url: this.$store.state.httpUrl+'/user/getLoginNew',
					method: 'GET',
					params:{
					}
				}).then((res) =>{
					if(res.data.status == 200){
						this.$set(this.$data,'contantVal',res.data.contantVal);
						this.$set(this.$data,'titleVal',res.data.titleVal);
						this.$set(this.$data,'totalAmount',res.data.totalAmount);

						if(res.data.data==500){
							this.colseDialog();
						}else{
							this.isShow=true;
						}

					}else{
						this.colseDialog();
					}
				}).catch((res) => {
					this.$notify.error({
						title: 'ERROR',
						message: 'Request failed, please try again later!'
					});
				})
			},



			//轮播图
			//开启定时器
			startInterval(){
				// 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
				clearInterval(this.timer);
				this.timer = setInterval(()=>{
					this.currentIndex++;

					if(this.currentIndex > this.imgArr.length-1){
						this.currentIndex = 0
					}
				},1800)
			},
			// 点击左右箭头
			clickIcon(val){
				if(val==='down'){
					this.currentIndex++;
					if(this.currentIndex===this.imgArr.length){
						this.currentIndex = 0;
					}
				}else{
					/* 第一种写法
					this.currentIndex--;
					if(this.currentIndex < 0){
						this.currentIndex = this.imgArr.length-1;
					} */
					// 第二种写法
					if(this.currentIndex === 0){
						this.currentIndex = this.imgArr.length;
					}
					this.currentIndex--;
				}
			},
			// 点击控制圆点
			changeImg(index){
				this.currentIndex = index
			},
			//鼠标移入移出控制
			changeInterval(val){
				if(val){
					clearInterval(this.timer)
				}else{
					this.startInterval()
				}
			},
			//进入页面后启动定时轮询
			mounted(){
				this.startInterval()
			},

			colseDialog:function(){

				this.isShow=false;


			}
		}
	}
</script>
<style lang="scss" scoped src="@/assets/sass/common.scss"></style>
<style lang="scss" scoped src="@/assets/sass/login.scss"></style>

